var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logoSrc)?_c('img',{staticClass:"lti-source-logo",attrs:{"src":_vm.logoSrc}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }